import React, {Component, useState} from 'react';
import {useDispatch} from "react-redux";
import {Link, useHistory} from "react-router-dom";
import {deleteBlog} from "../../../stores/blog/thunks";
import ModalAlerterCallback from "../../utils/ModalAlerterCallback";
import TableCell from "@mui/material/TableCell";
import {TableSortLabel} from "@mui/material";
import TableRow from "@mui/material/TableRow";
import separate from "../../functions/separate/separate";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Grid from "@mui/material/Grid";
import {ContainerHeader, SortableTableMat} from "../../module";
import AddIcon from '@mui/icons-material/Add';
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'center',
        padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    actions: {
        display: 'flex !important',
        flexDirection: 'row',
        gap: '0 10px'
    },
    editIcon: {
        color: '#FF8C00',
    },
    deleteIcon: {
        color: 'red',
    },
    viewEx: {
        color: '#0054a7',
    },
    item: {
        padding: '16px 8px',
    },
}));

const headCells = [
    {
        id: 'title',
        numeric: false,
        disablePadding: false,
        label: 'عنوان',
    },
    {
        id: 'category',
        numeric: false,
        disablePadding: false,
        label: 'دسته بندی',
    },
    {
        id: 'action',
        numeric: false,
        disablePadding: false,
        label: '',
        sort: true,
    },
];

export default function Blogs() {

    const dispatch = useDispatch();
    const history = useHistory();

    function removeProductType(productType_id, refreshTable) {
        const callback = () =>
            dispatch(deleteBlog(productType_id, refreshTable));
        ModalAlerterCallback(callback);
        // dispatch(deleteCoursesAdmin({ course_id }));
    }

    const ExerciseHeadMedel = (props) => {
        const classes = useStyles();
        const {headCell, order, orderBy} = props;

        return (
            <TableCell
                key={headCell.id}
                align={headCell.numeric ? 'right' : 'left'}
                padding={headCell.disablePadding ? 'none' : 'normal'}
                sortDirection={orderBy === headCell.id ? order : false}
            >
                <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : 'asc'}
                    // onClick={createSortHandler(headCell.id)}
                >
                    {headCell.label}
                    {orderBy === headCell.id ? (
                        <span className={classes.visuallyHidden}>
            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
          </span>
                    ) : null}
                </TableSortLabel>
            </TableCell>
        );
    };

    const ExerciseRowTableModel = (props) => {
        const classes = useStyles();
        const {row, onRemove, refreshTable} = props;

        function handleRemove() {
            onRemove(row.id, refreshTable);
        }

        return (
            <TableRow hover tabIndex={-1} key={row.id}>
                <TableCell align="left">{row?.title}</TableCell>
                <TableCell align="left">{row?.category}</TableCell>
                <TableCell align="left" className={classes.actions}>
                    <Link to={`/blog/${row.id}`}>
                        <Tooltip title="ویرایش">
                            <IconButton>
                                <EditIcon/>
                            </IconButton>
                        </Tooltip>
                    </Link>
                    <div onClick={handleRemove}>
                        <Tooltip title="حذف">
                            <IconButton>
                                <DeleteIcon/>
                            </IconButton>
                        </Tooltip>
                    </div>
                </TableCell>
            </TableRow>
        );
    };

    function addBlog() {
        history.push('/blog');
    }

    return (
        <Grid item xs={11} sm={12} className="d-flex flex-column DivParentCreateProduct">
            <ContainerHeader
                data={{
                    filter: false,
                    addBtn: true,
                }}
                headerTitle="لیست بلاگ ها"
                titleBtn="افزودن بلاگ"
                addBtnAction={addBlog}
                // filterAction={(value) => {
                //     handleSearch(value);
                // }}
            />
            <SortableTableMat
                link={'blog'}
                RowComponent={ExerciseRowTableModel}
                HeadCompnent={ExerciseHeadMedel}
                headers={headCells}
                onRemove={removeProductType}
            />
        </Grid>
    );
}